import { render, staticRenderFns } from "./loginRegist.vue?vue&type=template&id=462d7fcb&scoped=true"
import script from "./loginRegist.vue?vue&type=script&lang=js"
export * from "./loginRegist.vue?vue&type=script&lang=js"
import style0 from "./loginRegist.vue?vue&type=style&index=0&id=462d7fcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462d7fcb",
  null
  
)

export default component.exports